import { motion, useScroll } from 'framer-motion'
import PortfolioDialog from '../../components/PortfolioDialog'
import Educations from '../../components/Educations'
import Certificates from '../../components/Certificates'
import Experiences from '../../components/Experiences'
import Portfolio from '../../components/Portfolio'
import Contact from '../../components/Contact'
import Hero from '../../components/Hero'
import { Box } from '@chakra-ui/react'

const Home = () => {
  const { scrollYProgress } = useScroll()

  return (
    <Box>
      <Box
        as={motion.div}
        id="scroll-indicator"
        position={'fixed'}
        top={0}
        left={0}
        right={0}
        height={1}
        backgroundColor="green.600"
        zIndex={1}
        style={{
          scaleX: scrollYProgress,
          position: 'fixed',
          originX: 0
        }}
      />

      <Box>
        <PortfolioDialog />
        <Hero />
        <Educations />
        <Certificates />
        <Experiences />
        <Portfolio />
        <Contact />
      </Box>
    </Box>
  )
}

export default Home
